import getPermissions from "./utils/getPermissions";
import omitEmpty from "./utils/omitEmpty";
export default {
    get: function (token, auth) {
        var poll = {
            create: getPermissions(token, "recognition", ["polls"], ["create"]),
            delete: getPermissions(token, "recognition", ["polls"], ["delete"])
        };
        var rewards = {
            create: getPermissions(token, "recognition", ["rewards"], ["create"]),
            viewOff: getPermissions(token, "recognition", ["polls", "recognition"], ["read"], "rewardViewOff"),
            viewLimited: getPermissions(token, "recognition", ["polls", "recognition"], ["read"], "rewardViewLimited")
        };
        var recognition = {
            everyone: getPermissions(token, "recognition", ["recognition"], ["create"], "shareWithEveryone"),
            create: getPermissions(token, "recognition", ["recognition"], ["create", "read"]),
            update: getPermissions(token, "recognition", ["recognition"], ["update"], "allowAll")
        };
        var votes = {
            update: getPermissions(token, "recognition", ["votes"], ["update"], "allowAll")
        };
        var comments = {
            update: getPermissions(token, "recognition", ["comments"], ["update"], "allowAll"),
            delete: getPermissions(token, "recognition", ["comments"], ["delete"], "allowAll")
        };
        var permissions = {
            poll: omitEmpty(poll),
            rewards: omitEmpty(rewards),
            recognition: omitEmpty(recognition),
            votes: omitEmpty(votes),
            comments: omitEmpty(comments)
        };
        var applicationPermissions = omitEmpty(permissions);
        if (applicationPermissions && applicationPermissions.recognition) {
            applicationPermissions.recognition.rewardDisabled = auth.featureFlags.isRewardDisabled;
            applicationPermissions.recognition.reactions = auth.featureFlags.isRecognitionReactionsEnabled;
        }
        return applicationPermissions;
    }
};
